import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { PartService } from 'pages/quote-setup/parts/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, createButton } from 'resources/utility';
import toastr from 'toastr';

@inject(PartService, DialogService, EventAggregator)
export class Parts {
    constructor(partService, dialogService, ea) {
        this.ea = ea;
        this.partService = partService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'number', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'name' },
            { dataField: 'partType', allowFiltering: false },
            { dataField: 'location' },
            { dataField: 'purchasePartTypeName', caption: 'Purchase Type' },
            { dataField: 'defaultPrice' },
            { dataField: 'purchaseCost' },
            { caption: 'Actions' , allowExporting: false, cellTemplate: (container, options) =>  {
                const deleteButton = createButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete });
                deleteButton.style.marginRight = '20px';
                const cloneButton = createButton({ container, containerOptions: options, style: 'primary', label: 'Clone', action: this.clone });

                const div = document.createElement('div');
                div.appendChild(deleteButton);
                div.appendChild(cloneButton);
                container.append(div);
            }}
        ];

        this.subscription = this.ea.subscribe('parts:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (part) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.partService.delete(part.id);
                this.grid.refresh();
                toastr.success('Part was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.partService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.partService.editor, model: { id: data.id } });
    };

    clone = (data) => {
        this.dialogService.open({ viewModel: this.partService.editor, model: { clonePartId: data.id } });
    };
}